import { render, staticRenderFns } from "./OrganizationalReportModal.vue?vue&type=template&id=15520582"
import script from "./OrganizationalReportModal.vue?vue&type=script&lang=js"
export * from "./OrganizationalReportModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports